import { useIntl, defineMessages } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import FolderCard from '../Common/FolderCard';

const PersonaGalleria = (props) => {
  const intl = useIntl();
  const location = useLocation();
  const path = location.pathname;
  return (
    <RichTextArticle
      title={intl.formatMessage(messages.galleria_immagini_e_video)}
      tag_id="galleria_immagini_e_video"
    >
      <div className="container">
        <div className="row">
          <FolderCard
            url={`${path}/galleria-immagini`}
            title={intl.formatMessage(messages.galleria_immagini)}
          />
          <FolderCard
            url={`${path}/video`}
            title={intl.formatMessage(messages.galleria_video)}
          />
        </div>
      </div>
    </RichTextArticle>
  );
};

const messages = defineMessages({
  galleria_immagini_e_video: {
    id: 'galleria_immagini_e_video',
    defaultMessage: 'Galleria Immagini e Video',
  },
  galleria_immagini: {
    id: 'galleria_immagini',
    defaultMessage: 'Galleria Immagini',
  },
  galleria_video: {
    id: 'galleria_video',
    defaultMessage: 'Galleria Video',
  },
});

export default PersonaGalleria;
